import { useGlobalPanel } from '@frontend/panel-engine';
import { useMessageInsightsPanelShallowStore } from '../hooks/use-message-insights-panel-store';
import { MessageInsightsContent } from './message-insights-content';

export const MessageInsightsPanel = () => {
  const { isOpen, close: closeGlobal } = useGlobalPanel('message-insights');
  const { selectedMessage } = useMessageInsightsPanelShallowStore('selectedMessage');

  if (!isOpen || !selectedMessage) return null;

  return <MessageInsightsContent onClose={closeGlobal} />;
};
